// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXShop_base--1D5zE","base__overlayOpened":"WGCWXShop_base__overlayOpened--1Lm8x","baseOverlayOpened":"WGCWXShop_base__overlayOpened--1Lm8x","processing":"WGCWXShop_processing--_h-Nz"};


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/WGCWXShop.scss
// module id = 2451
// module chunks = 11